(() => {
  const TRANSITION_KEY = 'collectport:navigation-transition:v1';
  const SCROLL_KEY = 'collectport:return-scroll:v1';
  const MAX_AGE = 24 * 60 * 60 * 1000;
  const BACK_SELECTOR = [
    '[data-cp-product-back]',
    '.cp-singles-hub__back',
    '.cp-category-hub__back',
    '.cp-coll__back-btn'
  ].join(',');

  const readJson = (key) => {
    try { return JSON.parse(sessionStorage.getItem(key) || 'null'); }
    catch (_) { return null; }
  };

  const cleanTitle = (value) => String(value || '')
    .replace(/\s*[|–—-]\s*CollectPort.*$/i, '')
    .replace(/^Pokémon Sammelkartenspiel\s*/i, '')
    .trim();

  const sourceLabel = (url, title) => {
    const path = url.pathname.replace(/\/+$/, '') || '/';
    if (path === '/') return 'Zurück zur Startseite';
    if (path === '/pages/einzelkarten') return 'Zurück zur Einzelkarten-Auswahl';
    if (path === '/pages/pokemon-sets') return 'Zurück zur Pokémon-Setauswahl';
    if (path === '/pages/one-piece-sets') return 'Zurück zur One-Piece-Setauswahl';
    if (path === '/search') return 'Zurück zu den Suchergebnissen';
    if (path === '/cart') return 'Zurück zum Warenkorb';
    const readableTitle = cleanTitle(title);
    if (path.startsWith('/collections/') && readableTitle) return `Zurück zu ${readableTitle}`;
    if (readableTitle) return `Zurück zu ${readableTitle}`;
    return 'Zurück zur vorherigen Seite';
  };

  const currentHeading = () => cleanTitle(
    document.querySelector('main h1, .cp-coll__title, h1')?.textContent || document.title
  );

  const normalizePath = (url) => `${url.pathname.replace(/\/+$/, '') || '/'}${url.search}`;

  // Jede normale interne Navigation merkt sich die exakte Ausgangsseite.
  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href]');
    if (!link || link.matches(BACK_SELECTOR) || link.hasAttribute('download')) return;
    if (link.target && link.target !== '_self') return;
    try {
      const destination = new URL(link.href, location.href);
      if (destination.origin !== location.origin || destination.href === location.href) return;
      const source = new URL(location.href);
      sessionStorage.setItem(TRANSITION_KEY, JSON.stringify({
        fromUrl: source.href,
        fromPath: normalizePath(source),
        fromTitle: currentHeading(),
        fromScrollY: Math.max(0, Math.round(window.scrollY || 0)),
        toPathname: destination.pathname.replace(/\/+$/, '') || '/',
        savedAt: Date.now()
      }));
    } catch (_) {}
  }, true);

  const configureBackButtons = () => {
    const saved = readJson(TRANSITION_KEY);
    if (!saved?.fromUrl || Date.now() - Number(saved.savedAt || 0) > MAX_AGE) return;
    let origin;
    try { origin = new URL(saved.fromUrl, location.origin); }
    catch (_) { return; }
    const currentPath = location.pathname.replace(/\/+$/, '') || '/';
    if (
      origin.origin !== location.origin
      || origin.pathname === location.pathname
      || saved.toPathname !== currentPath
      || origin.pathname.startsWith('/products/')
    ) return;

    document.querySelectorAll(BACK_SELECTOR).forEach((button) => {
      button.href = origin.href;
      button.dataset.cpSmartBack = 'true';
      button.textContent = `← ${sourceLabel(origin, saved.fromTitle)}`;
      button.setAttribute('aria-label', sourceLabel(origin, saved.fromTitle));
    });
  };

  // Im Capture-Handler gewinnen wir bewusst gegen ältere, seitenbezogene
  // Back-Handler und verhindern widersprüchliche doppelte Navigationen.
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-cp-smart-back="true"]');
    if (!button || !button.matches(BACK_SELECTOR)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    try {
      const destination = new URL(button.href, location.origin);
      const saved = readJson(TRANSITION_KEY);
      sessionStorage.setItem(SCROLL_KEY, JSON.stringify({
        url: destination.href,
        scrollY: Math.max(0, Number(saved?.fromScrollY || 0)),
        savedAt: Date.now()
      }));
      location.assign(destination.href);
    } catch (_) {
      history.back();
    }
  }, true);

  const restoreScroll = () => {
    const saved = readJson(SCROLL_KEY);
    if (!saved?.url || Date.now() - Number(saved.savedAt || 0) > MAX_AGE) return;
    try {
      if (new URL(saved.url, location.origin).href !== location.href) return;
      sessionStorage.removeItem(SCROLL_KEY);
      const y = Math.max(0, Number(saved.scrollY || 0));
      requestAnimationFrame(() => {
        scrollTo(0, y);
        setTimeout(() => scrollTo(0, y), 180);
        setTimeout(() => scrollTo(0, y), 650);
      });
    } catch (_) {}
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      configureBackButtons();
      restoreScroll();
    }, { once: true });
  } else {
    configureBackButtons();
    restoreScroll();
  }
})();
